import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Image,
    Transfer,
    message,
    Divider,
    Rate,
    Popover
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import ReactPlayer from 'react-player'
import { CloseOutlined, FieldTimeOutlined } from '@ant-design/icons'
import {
    StarOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined,
    SearchOutlined,
    QrcodeOutlined
} from '@ant-design/icons'
import moment from 'moment';
import { ReactSVG } from "react-svg";
import weizhi from '../images/weizhi.png';
import Edit from './edit.js'
import Yuding from "./yuding";

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            condition2: {},
            visible: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
            that.getdata2()
        } else {
            that.props.refresh()
            that.setState({
                condition: {},
            })
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        fetch('/Room/detail', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.data,
                    condition2: data.contract ? data.contract : {}
                })
            })
    }
    getdata2() {
        let that = this
        let arr = {}
        arr.room_id = that.props.id
        fetch('/Room/qiyes', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    ...data
                })
            })
    }

    arrPiclist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Image key={index} src={item.url} width={100} height={100} />
            )
        }
    }

    arrVideolist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <ReactPlayer url={item.url} key={item.id} controls={true} width={"100%"} />
            )
        }
    }

    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }

    render() {
        const columns = [
            {
                title: '企业名称',
                dataIndex: 'company_name',
                key: 'company_name',
                // width:200,
                render: (row, record) => {
                    return (<>
                        <div>{row}</div>
                        {record.aliasname ? <div style={{ color: 'grey' }}>曾用名：{record.aliasname}</div> : null}
                    </>)
                },
            },
            {
                title: '租赁时间',
                dataIndex: 'zltime',
                key: 'zltime',
                render: (row, record) => {
                    return (<>
                        {record.stime} ~ {record.etime}
                    </>)
                },
            },
            {
                title: '合同状态',
                dataIndex: 'status_text',
                key: 'status_text',
                width: 100,
                fixed: 'right',
                render: (row, record) => {
                    return (<>
                        {record.status == 1 && <Tag color={'green'}>{row}</Tag>}
                        {record.status == 2 && <Tag color={'red'}>{row}</Tag>}
                        {record.status == 3 && <Tag color={'grey'}>{row}</Tag>}
                    </>)
                },
            }
        ]
        return (
            <>
                {this.props.title ?
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>{this.props.title}</a> :
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>查看</a>}

                <Modal title="查看详情" destroyOnClose={true} bodyStyle={{ padding: 15 }} width={800}
                    visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>
                            <span>房间信息</span>
                            <Space>
                                {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('2') ? <>
                                    <Edit refresh={this.getdata.bind(this)} id={this.props.id} />
                                </> : null) : null}
                                {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('2') ? <>
                                    {this.state.condition.yuding == 2 &&
                                        <Yuding type={1} title={<Button type={'primary'} icon={<FieldTimeOutlined />}
                                            className={'huang'}>预订</Button>}
                                            title2={'预订'}
                                            id={this.props.id}
                                            refresh={() => {
                                                this.props.refresh();
                                                this.getdata()
                                            }} />}
                                    {this.state.condition.yuding == 1 &&
                                        <Yuding type={2} title={<Button type={'primary'} icon={<FieldTimeOutlined />}
                                            className={'hui'}>取消预订</Button>}
                                            title2={'取消预订'}
                                            id={this.props.id}
                                            refresh={() => {
                                                this.props.refresh();
                                                this.getdata()
                                            }} />}
                                </> : null) : null}
                            </Space>
                        </div>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1'}>所属园区</div>
                                <div className={'p2'}>{this.state.condition.yq_id}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>楼栋</div>
                                <div className={'p2'}>{this.state.condition.building}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>房间号</div>
                                <div className={'p2'}>{this.state.condition.number}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>面积</div>
                                <div className={'p2'}>{this.state.condition.area}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>制冷状态</div>
                                <div className={'p2'}>
                                    {this.state.condition.zlstatus == 1 && <span style={{ color: '#52CC6f' }}>正常</span>}
                                    {this.state.condition.zlstatus == 0 &&
                                        <span style={{ color: '#bfbfbf' }}>已报停</span>}
                                </div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>供暖状态</div>
                                <div className={'p2'}>
                                    {this.state.condition.gnstatus == 1 && <span style={{ color: '#52CC6f' }}>正常</span>}
                                    {this.state.condition.gnstatus == 0 &&
                                        <span style={{ color: '#bfbfbf' }}>已报停</span>}
                                </div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>状态</div>
                                <div className={'p2'}>
                                    {this.state.condition.status == 1 &&
                                        <span style={{ color: 'red' }}>{this.state.condition.status_text}</span>}
                                    {this.state.condition.status == 2 &&
                                        <span style={{ color: 'blue' }}>{this.state.condition.status_text}</span>}
                                    {this.state.condition.status == 3 &&
                                        <span style={{ color: 'green' }}>{this.state.condition.status_text}</span>}
                                    {this.state.condition.status == 4 &&
                                        <span style={{ color: 'grey' }}>{this.state.condition.status_text}</span>}
                                </div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>备注</div>
                                <div className={'p2'}>
                                    <div dangerouslySetInnerHTML={{ __html: this.state.condition.bz }}></div>
                                </div>
                            </div>
                        </div>
                        {this.state.condition.company_id ? <>
                            <div className={'view_title'}>企业信息</div>
                            <div className={'view_info'}>
                                <div className={'item'}>
                                    <div className={'p1'}>企业名称</div>
                                    <div className={'p2'}>{this.state.condition.company_name}</div>
                                </div>
                                <div className={'item'}>
                                    <div className={'p1'}>法定代表人</div>
                                    <div className={'p2'}>{this.state.condition.corporation}</div>
                                </div>
                                <div className={'item'}>
                                    <div className={'p1'}>日常联系人</div>
                                    <div className={'p2'}>{this.state.condition.contacts}</div>
                                </div>
                                <div className={'item'}>
                                    <div className={'p1'}>日常联系人电话</div>
                                    <div className={'p2'}>{this.state.condition.phone}</div>
                                </div>
                                <div className={'item'}>
                                    <div className={'p1'}>紧急联系人</div>
                                    <div className={'p2'}>{this.state.condition.emcontacts}</div>
                                </div>
                                <div className={'item'}>
                                    <div className={'p1'}>紧急联系人电话</div>
                                    <div className={'p2'}>{this.state.condition.emphone}</div>
                                </div>
                            </div>
                        </> : null}
                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('1') ? <>
                            {this.state.condition.contract_id ? <>
                                <div className={'view_title'}>合同信息</div>
                                <div className={'view_info'}>
                                    <div className={'item'}>
                                        <div className={'p1'}>企业名称</div>
                                        <div className={'p2'}>{this.state.condition2.company_name}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>合同编号</div>
                                        <div
                                            className={'p2'}>{this.state.condition2.ref} {this.state.condition.czwt == 1 &&
                                                <Tag color={'red'}>存在问题</Tag>}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>租赁时间</div>
                                        <div className={'p2'}>{this.state.condition2.zltime}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>租赁时长</div>
                                        <div className={'p2'}>{this.state.condition2.duration}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>免租期时间</div>
                                        <div className={'p2'}>{this.state.condition2.mz_stime}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>免租期月数</div>
                                        <div className={'p2'}>{this.state.condition2.mz_duration}</div>
                                    </div>
                                    <div className={'item all'}>
                                        <div className={'p1'}>免租期月度应收管理服务费</div>
                                        <div className={'p2'}>{this.state.condition2.mz_service}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>正常期时间</div>
                                        <div className={'p2'}>{this.state.condition2.zc_stime}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>正常期月数</div>
                                        <div className={'p2'}>{this.state.condition2.zc_duration}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>正常期月度应收租赁费</div>
                                        <div className={'p2'}>{this.state.condition2.rent}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>租金标准</div>
                                        <div className={'p2'}>{this.state.condition2.zjbz}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>正常期月度应收管理服务费</div>
                                        <div className={'p2'}>{this.state.condition2.service}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>管理服务费标准</div>
                                        <div className={'p2'}>{this.state.condition2.glfwfbz}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>制冷费</div>
                                        <div className={'p2'}>{this.state.condition2.zlcost}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>采暖费</div>
                                        <div
                                            className={'p2'}>{this.state.condition2.cncost} {this.state.condition2.cncost_fd_text ? `【${this.state.condition2.cncost_fd_text}】` : null}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>保证金</div>
                                        <div className={'p2'}>{this.state.condition2.guarantee}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>装修保证金</div>
                                        <div className={'p2'}>{this.state.condition2.zx_guarantee}</div>
                                    </div>
                                    <div className={'item all'}>
                                        <div className={'p1'}>合同附件</div>
                                        <div className={'p2'}>
                                            <Space wrap direction={"vertical"}>
                                                {this.arrfjlist(this.state.condition2.fjlist)}
                                            </Space>
                                        </div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>合同状态</div>
                                        <div className={'p2'}>
                                            {this.state.condition2.status == 1 &&
                                                <Tag color={'green'}>{this.state.condition2.status_text}</Tag>}
                                            {this.state.condition2.status == 2 &&
                                                <Tag color={'red'}>{this.state.condition2.status_text}</Tag>}
                                        </div>
                                    </div>
                                </div>
                            </> : null}
                        </> : null) : null}
                        {
                            this.state.condition.map ? <>
                                <div className={'view_title'}>房间位置图</div>
                                <div className={'view_info'} style={{ cursor: 'zoom-in' }} title={'点击预览'}
                                    onClick={() => {
                                        this.setState({ previer_open: !this.state.previer_open })
                                    }}>
                                    <ReactSVG src={this.state.condition.map}
                                        style={{ width: '100%' }}
                                        afterInjection={(svg) => {
                                            // console.log(svg.querySelectorAll('.st2'))
                                            let arr = svg.querySelectorAll("rect");
                                            let arr2 = svg.querySelectorAll("polygon")
                                            arr = [...arr, ...arr2];
                                            arr = arr.filter((item) => item.id)
                                            let arr3 = svg.querySelectorAll(".area")
                                            arr.forEach((item, index) => {
                                                item.style.fill = "#DFE1E5"
                                                if (item.id == this.state.condition.room_id) {
                                                    switch (this.state.condition.status2) {
                                                        case 1:
                                                            item.style.fill = "#FF3030"
                                                            break;
                                                        case 2:
                                                            item.style.fill = "#18AE3E"
                                                            break;
                                                        case 3:
                                                            item.style.fill = "#217DE2"
                                                            break;
                                                        case 4:
                                                            item.style.fill = "#F78B37"
                                                            break;
                                                        case 5:
                                                            item.style.fill = "#7552FF"
                                                            break;
                                                        default:
                                                            item.style.fill = "#DFE1E5"
                                                            break
                                                    }
                                                } else {
                                                    // item3.style.fill = "#DFE1E5"
                                                }
                                            })
                                            if (this.state.condition.map_rooms && this.state.condition.map_rooms.length) {
                                                arr3.forEach((item3, index3) => {
                                                    item3.textContent = "待定"
                                                    this.state.condition.map_rooms.map((item2, index2) => {
                                                        if (item3.id == item2.number + '-area') {
                                                            item3.innerHTML = `<tspan x="0" dy="0">${item2.area}</tspan><tspan x="${item2.x ? item2.x : 0}" dy="20">${item2.qyjc ? item2.qyjc : ''}</tspan>`
                                                        }
                                                    })
                                                })
                                            }

                                        }}
                                    />
                                </div>
                            </> : null
                        }
                        {this.state.condition.imglist && this.state.condition.imglist.length ? <>
                            <div className={'view_title'}>图片</div>
                            <div className={'view_info'}>
                                <Image.PreviewGroup
                                    preview={{
                                        onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                                    }}
                                >
                                    <Space wrap>
                                        {this.arrPiclist(this.state.condition.imglist)}
                                    </Space>
                                </Image.PreviewGroup>
                            </div>
                        </> : null}
                        {this.state.condition.videolist && this.state.condition.videolist.length ? <>
                            <div className={'view_title'}>视频</div>
                            <div className={'view_info'} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                                {this.arrVideolist(this.state.condition.videolist)}
                            </div>
                        </> : null}
                        {this.state.datalist && this.state.datalist.length ? <>
                            <div className={'view_title'}>历史租赁企业</div>
                            <div className={'view_info'}>
                                <Table
                                    bordered
                                    columns={columns}
                                    dataSource={this.state.datalist}
                                    pagination={false}
                                    style={{ marginBottom: 20, width: '100%' }}
                                />
                            </div>
                        </> : null}
                    </div>
                </Modal>
                <Modal title="图片预览" destroyOnClose={true} bodyStyle={{ padding: 15 }} width={1600}
                    visible={this.state.previer_open} onCancel={() => {
                        this.setState({ previer_open: !this.state.previer_open })
                    }} footer={null}>
                    <ReactSVG src={this.state.condition.map}
                        style={{ width: '100%' }}
                        afterInjection={(svg) => {
                            // console.log(svg.querySelectorAll('.st2'))
                            let arr = svg.querySelectorAll("rect");
                            let arr2 = svg.querySelectorAll("polygon")
                            arr = [...arr, ...arr2];
                            arr = arr.filter((item) => item.id)
                            let arr3 = svg.querySelectorAll(".area")
                            arr.forEach((item, index) => {
                                item.style.fill = "#DFE1E5"
                                if (item.id == this.state.condition.room_id) {
                                    switch (this.state.condition.status2) {
                                        case 1:
                                            item.style.fill = "#FF3030"
                                            break;
                                        case 2:
                                            item.style.fill = "#18AE3E"
                                            break;
                                        case 3:
                                            item.style.fill = "#217DE2"
                                            break;
                                        case 4:
                                            item.style.fill = "#F78B37"
                                            break;
                                        case 5:
                                            item.style.fill = "#7552FF"
                                            break;
                                        default:
                                            item.style.fill = "#DFE1E5"
                                            break
                                    }
                                } else {
                                    // item3.style.fill = "#DFE1E5"
                                }
                            })
                            if (this.state.condition.map_rooms && this.state.condition.map_rooms.length) {
                                arr3.forEach((item3, index3) => {
                                    item3.textContent = "待定"
                                    this.state.condition.map_rooms.map((item2, index2) => {
                                        if (item3.id == item2.number + '-area') {
                                            item3.innerHTML = `<tspan x="0" dy="0">${item2.area}</tspan><tspan x="${item2.x ? item2.x : 0}" dy="20">${item2.qyjc ? item2.qyjc : ''}</tspan>`
                                        }
                                    })
                                })
                            }
                            /* arr3.forEach((item3, index3) => {
                                 item3.textContent = "待定"
                                 if (item3.id == this.state.condition.room_id + '-area') {
                                     item3.textContent = this.state.condition.area + "㎡"
                                 } else {
                                     // item3.style.fill = "#DFE1E5"
                                 }
                             })*/
                        }}
                    />
                </Modal>
            </>
        )
    }
}

export default DwView
